module.exports = __webpack_public_path__ + "media/images/flags/16/Laos-6956b38c2a574b7b5d652cf8e66310a4.png";